import { render, staticRenderFns } from "./ExpenseTable.vue?vue&type=template&id=3a12dee0"
import script from "./ExpenseTable.vue?vue&type=script&lang=js"
export * from "./ExpenseTable.vue?vue&type=script&lang=js"
import style0 from "./ExpenseTable.vue?vue&type=style&index=0&id=3a12dee0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports